import { render, staticRenderFns } from "./FinalizeRecommendedModal.vue?vue&type=template&id=12a0aedc"
import script from "./FinalizeRecommendedModal.vue?vue&type=script&lang=js"
export * from "./FinalizeRecommendedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports